export default __webpack_public_path__ + "static/media/13-100.a03e1a7b.jpg";